export default {
    setOpenModalKey: modalKey => ({
        type: 'SQR_SET_OPEN_MODAL_KEY',
        modalKey,
    }),
    setErrorMessage: ({ errorMessage }) => ({
        type: 'SQR_SET_ERROR_MSG',
        errorMessage,
    }),
    setCurrentStep: step => ({
        type: 'SQR_SET_CURRENT_STEP',
        step,
    }),
    clearState: () => ({
        type: 'SQR_CLEAR_STATE',
    }),
};
